import { IUserMilestone } from '../../IUserMilestone';

export const SHOPIFY_LEAD_UPGRADED_PLAN =
  'SHOPIFY_LEAD_UPGRADED_PLAN' as IUserMilestone.RetailerMilestone;
